const Strings = {
  MY_BOOKINGS: {
    SE: 'Mina bokningar',
    EN: 'My bookings'
  },
  NO: {
    SE: 'Nej',
    EN: 'No'
  },
  YES: {
    SE: 'Ja',
    EN: 'Yes'
  },
  REQUEST_UNBOOK_TIME: {
    SE: 'Avboka tid',
    EN: 'Unbook time'
  },
  REQUEST_UNBOOK_TIME_INFO: {
    SE: 'Är du säker på att du vill avboka tiden?',
    EN: 'Are you sure your wish to unbook the time?'
  },
  LAUNDRY: {
    S: {
      SE: 'Tvättstuga',
      EN: 'Laundry room'
    },
    M: {
      SE: 'Tvättmaskin',
      EN: 'Laundry machine'
    }
  },
  UNBOOK: {
    SE: 'Avboka',
    EN: 'Unbook'
  },
  NO_BOOKINGS: {
    SE: 'Du har inga bokningar',
    EN: 'You have no bookings'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/containers/MyBookingsHandler/strings.js